import * as z from 'zod'
import { Form, FormField, FormItem, FormLabel } from '@/components/ui/form'
import { formSchema } from './page'
import { VoiceSelector } from '@/components/voiceSelector'
import { WinConditionFormField } from '@/components/settings/WinCondition'
import { AIUsage } from '@/components/settings/AIUsage'

export const Configuration = ({ form, onNext, controlBtns, setIsAIProcessing }) => {
  const onSubmit = (values: z.infer<typeof formSchema>) => {
    if (onNext) onNext(values)
  }

  const onErrors = (errors: any) => {}

  return (
    <div className="h-full  flex flex-col p-4 overflow-auto noScrollbar">
      <Form {...form} className="h-full">
        <form
          onSubmit={form.handleSubmit(onSubmit, onErrors)}
          className="flex flex-col h-full space-y-4 min-h-[500px]"
        >
          <FormField
            control={form.control}
            name="winType"
            render={({ field }) => <WinConditionFormField field={field} form={form} />}
          />

          <h5 className="text-sm flex w-full items-center justify-between whitespace-nowrap font-semibold">
            AI Voice Options <span className="w-3/4 h-[1px] bg-white" />
          </h5>

          <div className="flex w-full space-x-4">
            <FormField
              control={form.control}
              name="globalAI"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel className="text-sm">AI Personality #1</FormLabel>
                  <VoiceSelector
                    onValueChange={(val: string) => field.onChange(Number(val))}
                    defaultValue={field.value}
                    disabled={false}
                    preferredGender="female"
                  />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="bot1"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel className="text-sm">AI Personality #2</FormLabel>
                  <VoiceSelector
                    onValueChange={(val: string) => field.onChange(Number(val))}
                    defaultValue={field.value}
                    disabled={false}
                    preferredGender="male"
                    preferredName="Andrew"
                  />
                </FormItem>
              )}
            />
          </div>

          <div className="!mt-auto mb-4">
            {/* <FormField
              control={form.control}
              name="aiEnabled"
              render={({ field }) => <AIUsage field={field} form={form} />}
            /> */}
            {controlBtns}
          </div>
        </form>
      </Form>
    </div>
  )
}
